import * as __glob_0 from './../cmx-system-cards.ts';
import * as __glob_1 from './../cta-banner.ts';
import * as __glob_2 from './../cycle.ts';
import * as __glob_3 from './../feature-tabs.ts';
import * as __glob_4 from './../footer.ts';
import * as __glob_5 from './../form.ts';
import * as __glob_6 from './../hero.ts';
import * as __glob_7 from './../nav-banner-marquee.ts';
import * as __glob_8 from './../nav.ts';
import * as __glob_9 from './../recognition-wrap.ts';
import * as __glob_10 from './../rotate-slider.js';
import * as __glob_11 from './../scatter-cta.ts';
import * as __glob_12 from './../split-block-read-more.ts';
import * as __glob_13 from './../split.ts';
import * as __glob_14 from './../stats-slider.ts';
import * as __glob_15 from './../step-accordion.js';
import * as __glob_16 from './../swiper-slider.js';
import * as __glob_17 from './../tabs.js';
import * as __glob_18 from './../test.ts';
const modules = { "./../cmx-system-cards.ts": __glob_0, "./../cta-banner.ts": __glob_1, "./../cycle.ts": __glob_2, "./../feature-tabs.ts": __glob_3, "./../footer.ts": __glob_4, "./../form.ts": __glob_5, "./../hero.ts": __glob_6, "./../nav-banner-marquee.ts": __glob_7, "./../nav.ts": __glob_8, "./../recognition-wrap.ts": __glob_9, "./../rotate-slider.js": __glob_10, "./../scatter-cta.ts": __glob_11, "./../split-block-read-more.ts": __glob_12, "./../split.ts": __glob_13, "./../stats-slider.ts": __glob_14, "./../step-accordion.js": __glob_15, "./../swiper-slider.js": __glob_16, "./../tabs.js": __glob_17, "./../test.ts": __glob_18 };
// console.log("modules -> []", modules);

// Extend HTMLElement interface to include our custom property
declare global {
  interface HTMLElement {
    _moduleInitialized?: boolean;
  }
}

export function createCycles(dataAttribute = "module") {
  return Array.from(document.querySelectorAll(`[data-${dataAttribute}]`))
    .map((element) => {
      const htmlElement = element as HTMLElement;
      const attributeValue = htmlElement.dataset[dataAttribute];

      // Check if THIS SPECIFIC ELEMENT is already initialized
      if (htmlElement._moduleInitialized) {
        return null; // Skip this specific element
      }

      const modulePath = modules[`./../${attributeValue}.ts`]
        ? `./../${attributeValue}.ts`
        : `./../${attributeValue}.js`;

      if (modules[modulePath]) {
        // Expecting a default export function
        const moduleFn = (
          modules[modulePath] as {
            default: (el: HTMLElement, dataset: DOMStringMap) => any;
          }
        ).default;
        if (typeof moduleFn === "function") {
          try {
            // Mark THIS SPECIFIC ELEMENT as initialized
            htmlElement._moduleInitialized = true;

            return moduleFn(htmlElement, htmlElement.dataset);
          } catch (error) {
            // Remove the flag if initialization fails
            delete htmlElement._moduleInitialized;
            console.warn(
              `Failed to call default function for ${dataAttribute} "${attributeValue}":`,
              error
            );
            return null;
          }
        } else {
          console.warn(
            `Default export is not a function for ${dataAttribute} "${attributeValue}"`
          );
          return null;
        }
      } else {
        console.warn(`${dataAttribute} not found: "${attributeValue}"`);
        return null;
      }
    })
    .filter((item) => item !== null);
}

// Optional: Helper function to manually clear initialization for testing
export function clearModuleInitialization(element: HTMLElement) {
  delete element._moduleInitialized;
}
